

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const UPDATEAPPRAISALYEAR= createAsyncThunk(
  "updateAppraisalYear/updateAppraisalYear",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateAppraisalYearSlice = createSlice({
  name: "updateAppraisalYearSlice",
  initialState: {
    updateAppraisalYear: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateAppraisalYear: (state) => {
        state.updateAppraisalYear.loading = false
        state.updateAppraisalYear.error = false
        state.updateAppraisalYear.data = []
        state.updateAppraisalYear.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEAPPRAISALYEAR.fulfilled, (state, action) => {
      state.updateAppraisalYear = {
        ...state.updateAppraisalYear,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEAPPRAISALYEAR.pending, (state, action) => {
      state.updateAppraisalYear = {
        ...state.updateAppraisalYear,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEAPPRAISALYEAR.rejected, (state, action) => {
      state.updateAppraisalYear = {
        ...state.updateAppraisalYear,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateAppraisalYearAction = {
    UPDATEAPPRAISALYEAR,
};

export { updateAppraisalYearAction };
export default updateAppraisalYearSlice.reducer;
export const {setInitialStateOfupdateAppraisalYear} = updateAppraisalYearSlice.actions
